module.exports = __webpack_public_path__ + "static/icon-experts-ac24e0b1b54883b98b1c5be8adc91315.png";